import LazyLoadElementWrapper from './LazyLoadElementWrapper';

export default abstract class AbstractLazyLoad {
  private targetElementsWrappers: LazyLoadElementWrapper[];
  private eventHandler = () => {
    this.checkAndLoad();
  };

  constructor(containerSelector: string) {
    this.targetElementsWrappers = Array
      .from(document.querySelectorAll<HTMLElement>(containerSelector))
      .map((element: HTMLElement) => new LazyLoadElementWrapper(element));
  }

  public initialize(): void {
    window.addEventListener('scroll', this.eventHandler);
    this.checkAndLoad();
  }

  protected abstract load(wrapper?: LazyLoadElementWrapper): void;

  private checkAndLoad(): void {
    this.targetElementsWrappers
      .filter(element => element.canBeLoaded)
      .forEach((element) => {
        this.load(element);
        element.isLoaded = true;
      });

    if (this.isAllLoaded) {
      window.removeEventListener('scroll', this.eventHandler);
    }
  }

  private get isAllLoaded(): boolean {
    return this.targetElementsWrappers.every(element => element.isLoaded);
  }
};
